// src/pages/RefundPolicy.js
import CmsPage from "../components/pages/CmsPage";

export default function RefundPolicy() {
  return (
    <CmsPage
      slug="refund_policy"
      fallbackTitle="Refund Policy"
      fallbackContent=""
    />
  );
}
